/**
 * @file 概览卡片组件
 */
<template>
  <div class="p-overview-card">
    <div v-if="title" class="p-overview-card__title">
      {{ title }}
      <div class="p-overview-card__subTitle">
        <slot name="subTitle"></slot>
      </div>
    </div>
    <div class="p-overview-card__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
  }
};
</script>

<style lang="scss">
.p-overview-card {
  border: 1px solid #ececec;
  border-radius: 2px;
  padding: 15px 20px;
  min-width: 266px;
  font-size: 16px;
  box-sizing: border-box;
  &__title {
    padding-bottom: 10px;
    border-bottom: 1px solid #ececec;
    display: flex;
    font-weight: 500;
    justify-content: space-between;
  }
}
</style>
